import { DateISOString } from '@web-shared/utils/time/types';
import { Lat, Lng } from '@web-shared/types/Map.types';
import { PHOTO_TYPE } from './PhotoType';
import { EBOL_STATUS } from './EbolStatus';

export interface EbolPhoto {
  id: number;
  photo_type?: PHOTO_TYPE;
  name?: string;
  picture_url: string;
}

export interface ShipmentAttachment {
  id: number;
  attachment_key: string;
  created_at: DateISOString;
  photo_type: PHOTO_TYPE;
  picture_url: string;
}

export interface ShipmentIdentifier {
  oh_id: number;
  shipment: string;
  carrier: string;
  shipper: string;
  tracking: string;
  custom_id: string;
  master_awb_number: string;
  house_awb_number: string;
  mbol: string;
  hbol: string;
  container_number: string;
}

export interface EbolDetails {
  id: number;
  destination_lat_lng?: [Lat, Lng],
  reference_number: string;
  created_at: DateISOString;
  updated_at?: DateISOString;
  destination_title: string;
  source?: EBOL_SOURCE;
  status?: EBOL_STATUS;
  photos: EbolPhoto[];
}

export enum EBOL_SOURCE {
  SECURE_BOL = 'secure_bol',
  SHIPMENT_CONNECT = 'shipment_connect',
}
export interface ShipmentEbolDetails {
  id: number;
  created_at: DateISOString;
  destination_title: string;
  identifiers: ShipmentIdentifier;
  photos: ShipmentAttachment[];
}

export interface EbolDetailsResponse {
  id: number;
  ebol: EbolDetails;
  shipment?: ShipmentEbolDetails;
}

export interface PodUploadResponse {
  id: number;
  photo_type: PHOTO_TYPE;
  picture_url: string;
}